import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-hidden-cost-panel-damage',
  templateUrl: './hidden-cost-panel-damage.component.html',
  styleUrls: ['./hidden-cost-panel-damage.component.scss']
})
export class HiddenCostPanelDamageComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('The Hidden Cost of Panel Damage in Schools & How to Avoid It | Virsa');
    this.metaService.updateTag({ name: 'description', content: 'Discover the hidden costs of interactive panel damage in schools and how Virsa IFP sliding shutters protect your investment and reduce maintenance expenses.' });
    this.metaService.updateTag({ name: 'keywords', content: 'panel damage cost in schools, interactive panel protection, IFP sliding shutters, protect interactive flat panels, smart classroom maintenance, Virsa IFP shutters' });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
